import script from "./SpineTape.vue?vue&type=script&setup=true&lang=js"
export * from "./SpineTape.vue?vue&type=script&setup=true&lang=js"

import "./SpineTape.vue?vue&type=style&index=0&id=3b52c947&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b52c947"]])

export default __exports__